<div class="h-100 d-flex flex-column align-items-center justify-content-center">
    <div class="fade-in">
        <img width="300" src="../../../assets/images/logo-2.png" alt=""/>
    </div>
    
    <br>
    <div class="tagline">
        <p>Automate Your Engineering</p>
    </div>
    <br>
    <div class="message">
        Not Found!
    </div>
    <div class="sub-message">No active license found! Contact Drawout admin</div>
    <br>
    <!-- <button>Contact Support</button> -->
    <br>
</div>